export default class DentalRaterPriceInsuredToSave {
  /** (String): Código postal del asegurado. */
  postalCode!: string

  /** (DateTime): Fecha de nacimiento del asegurado. */
  birthDate!: string

  /** (Integer): Orden del asegurado. */
  riskNumber!: number

  /** (String): Tipo de parentesco con el titular. */
  relationship?: string

  /** (Boolean): Indicador si el asegurado tiene seguro de salud. */
  hasHealthPolicy!: boolean

  constructor(data: any) {
    if (data.postalCode) this.postalCode = data.postalCode
    this.birthDate = data.birthDate
    this.riskNumber = data.riskNumber
    this.relationship = data.relationship
    this.hasHealthPolicy = data.hasHealthPolicy
  }
}
